/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FolderPlusIcon16Light } from './FolderPlusIcon16Light';
import { FolderPlusIcon16Regular } from './FolderPlusIcon16Regular';
import { FolderPlusIcon16Solid } from './FolderPlusIcon16Solid';
import { FolderPlusIcon20Light } from './FolderPlusIcon20Light';
import { FolderPlusIcon20Regular } from './FolderPlusIcon20Regular';
import { FolderPlusIcon20Solid } from './FolderPlusIcon20Solid';
import { FolderPlusIcon24Regular } from './FolderPlusIcon24Regular';
import { FolderPlusIcon24Solid } from './FolderPlusIcon24Solid';
import { FolderPlusIcon32Regular } from './FolderPlusIcon32Regular';
import { FolderPlusIcon64Regular } from './FolderPlusIcon64Regular';
var sizes = {
    16: {
        light: FolderPlusIcon16Light,
        regular: FolderPlusIcon16Regular,
        solid: FolderPlusIcon16Solid,
    },
    20: {
        light: FolderPlusIcon20Light,
        regular: FolderPlusIcon20Regular,
        solid: FolderPlusIcon20Solid,
    },
    24: {
        regular: FolderPlusIcon24Regular,
        solid: FolderPlusIcon24Solid,
    },
    32: {
        regular: FolderPlusIcon32Regular,
    },
    64: {
        regular: FolderPlusIcon64Regular,
    },
};
export var FolderPlusIcon = forwardRef('FolderPlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
